<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="43" viewBox="0 0 64 43">
    <g clip-path="url(#clip0_2959_1109)">
      <path
        d="M50.8326 40.3019C56.7678 40.3019 61.5793 35.4905 61.5793 29.5553C61.5793 23.62 56.7678 18.8086 50.8326 18.8086C44.8974 18.8086 40.0859 23.62 40.0859 29.5553C40.0859 35.4905 44.8974 40.3019 50.8326 40.3019Z"
        stroke="currentcolor"
        stroke-width="4"
        stroke-miterlimit="10"
        fill="none"
      />
      <path
        d="M50.831 29.5554L40.4844 2.96875H49.8177"
        stroke="currentcolor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M13.6583 40.3019C19.5935 40.3019 24.405 35.4905 24.405 29.5553C24.405 23.62 19.5935 18.8086 13.6583 18.8086C7.72307 18.8086 2.91162 23.62 2.91162 29.5553C2.91162 35.4905 7.72307 40.3019 13.6583 40.3019Z"
        stroke="currentcolor"
        stroke-width="4"
        stroke-miterlimit="10"
        fill="none"
      />
      <path
        d="M13.6592 29.5555H31.2592L43.9792 12.9155H23.4458L13.6592 29.5555Z"
        stroke="currentcolor"
        stroke-width="4"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M31.2574 29.5555L20.5107 6.08887"
        stroke="currentcolor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5913 5.10254H25.3913"
        stroke="currentcolor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M49.8179 2.96875C51.3912 2.96875 52.6712 4.24875 52.6712 5.82208C52.6712 7.39542 51.3912 8.67542 49.8179 8.67542"
        stroke="currentcolor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2959_1109">
        <rect width="62.6667" height="41.3333" fill="white" transform="translate(0.911621 0.96875)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
